import { AvatarIcon } from "../Avatar"
import excludeIcon from "../../assets/icons/exclude.svg"
import {
  BsFiletypeCsv,
  BsFiletypeDocx,
  BsFiletypePdf,
  BsFiletypePptx,
  BsFiletypeXlsx,
} from "react-icons/bs"
import { truncate } from "lodash"
import { isMobile } from "react-device-detect"
import "./styles.scss"
import { IoClose } from "react-icons/io5"

export const MessageBox = ({ hasActions, message, removePinnedMessage, questionId }) => {
  if (!message) {
    return <></>
  }

  const userName =
    message?.userName || message?.username || message?.userEmail || message?.useremail || "Produtor"

  return (
    <div className="assistance_message__container">
      <header className="assistance_message_header">
        <div className="profile">
          <AvatarIcon title={userName} backgroundColor="random" name={userName} />
          <h5>{isMobile ? truncate(userName, { length: 20 }) : userName}</h5>
        </div>
        {hasActions && (
          <div className="profile-action" onClick={() => removePinnedMessage(message?.id, questionId || null)}>
            <img src={excludeIcon} alt="remover chat" />
          </div>
        )}
      </header>
      {message?.projectName && (
        <div className="message_subheader">{message?.projectName || ""}</div>
      )}
      {/* <p className="message_content">{message?.content}</p> */}
      {textVerification(message)}
    </div>
  )
}


export const EvidenceBox = ({ evidences, questionId, handleRemoveEvidence, hasActions = false }) => {
  const evidencesMapped = Array.isArray(evidences)
    ? evidences.map((item, idx) => ({
      ...item,
      id: item?.url || idx,
      attachment: {
        remotePath: item?.url,
        contentType: item?.fileType || item?.contentType,
      },
    }))
    : [];

  return (
    <div className="assistance_evidence__container">
      {evidencesMapped.length > 0 ? (
        evidencesMapped.map((item) => (
          <div key={item.id} style={{ position: 'relative' }}>
            {textVerification(item)}
            {hasActions && (
              <button
                onClick={() => handleRemoveEvidence(questionId, item.id)}
                className="remove-image-button"
              >
                <IoClose />
              </button>
            )}
          </div>
        ))
      ) : (
        <p>Não há evidências disponíveis</p>
      )}
    </div>
  );
}

const MessageDocComponent = ({ item }) => {
  const handleAttachmentClick = () => {
    if (item.attachment) {
      window.open(item.attachment.remotePath)
    }
  }

  const getFileIcon = () => {
    if (item.attachment) {
      if (item.attachment.contentType.includes("pdf")) {
        return <BsFiletypePdf size={20} />
      } else if (item.attachment.contentType.includes(".document")) {
        return <BsFiletypeDocx size={20} />
      } else if (item.attachment.contentType.includes(".sheet")) {
        return <BsFiletypeXlsx size={20} />
      } else if (item.attachment.contentType.includes(".presentation")) {
        return <BsFiletypePptx size={20} />
      } else if (item.attachment.contentType.includes("csv")) {
        return <BsFiletypeCsv size={20} />
      }
    }
    return null
  }

  const isAttachmentValid =
    !item.attachment ||
    (!item.attachment.contentType.includes("csv") &&
      !item.attachment.contentType.includes(".presentation") &&
      !item.attachment.contentType.includes(".sheet") &&
      !item.attachment.contentType.includes(".document") &&
      !item.attachment.contentType.includes("pdf"))

  return (
    <div className={`message-doc`} onClick={handleAttachmentClick} title="Documento">
      {getFileIcon()}
      {isAttachmentValid ? (
        <span className="message-doc-name" title={item.message}>
          {item.message}
        </span>
      ) : (
        <span className="message-doc-name" title={item.attachment?.name}>
          {item.attachment?.name}
        </span>
      )}
    </div>
  )
}

const renderImage = (item) => <img src={item.attachment.remotePath} className="img-chat" />

const renderAudio = (item) => (
  <audio
    id="audio"
    controls
    src={`${item.attachment.remotePath}`}
    className="audio-component"></audio>
)

const renderVideo = (item) => (
  <video src={item.attachment.remotePath} width="320" height="240" controls id="video" />
)

const textVerification = (item) => {
  if (
    item &&
    item.attachment &&
    item.attachment.contentType &&
    typeof item.attachment.contentType === "string"
  ) {
    if (item.attachment.contentType.includes("image")) {
      return renderImage(item)
    } else if (item.attachment.contentType.includes("audio")) {
      return renderAudio(item)
    } else if (item.attachment.contentType.includes("video")) {
      return renderVideo(item)
    } else {
      return <MessageDocComponent {...{ item }} />
    }
  } else {
    return <text className={`message`}>{item?.content || ""}</text>
  }
}

export default textVerification
